import styled, { css, keyframes } from 'styled-components'
import { MOBILE_WIDTH } from 'utils/constants'

// Animação de loading
const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const spinAnimation = css`
  animation: ${spin} 1s linear infinite;
`

export const RegistrationFormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  width: 100%;
  margin-bottom: 2rem;
`

export const InvisibleContainer = styled.div`
  height: 1px;
  width: 100%;

  @media ${MOBILE_WIDTH} {
    display: none;
  }
`

interface VariableWidthContainerProps {
  width: string
}
export const VariableWidthContainer = styled.div<VariableWidthContainerProps>`
  width: ${({ width }) => width};

  @media ${MOBILE_WIDTH} {
    width: 100%;
  }
`

export const PasswordGuidelines = styled.p`
  padding: 2px 0;
  line-height: 1.5;
  font-size: 0.885rem;
  color: #9c9c9c;
  margin-top: 0.5rem;
`

export const DocumentSection = styled.div`
  width: 100%;
  margin: 1rem 0;
`

export const DocumentTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #00607f;
  margin-bottom: 0.5rem;
`

export const DocumentDescription = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
`

export const DocumentsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  width: 100%;

  @media ${MOBILE_WIDTH} {
    grid-template-columns: 1fr;
  }
`

const getBorderColor = (hasFile?: boolean, hasError?: boolean) => {
  if (hasError) return '#ef4444'
  if (hasFile) return '#02b0bb'
  return '#d1d5db'
}

export const CompactUpload = styled.div<{ hasFile?: boolean; hasError?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  border: 2px dashed ${({ hasFile, hasError }) => getBorderColor(hasFile, hasError)};
  border-radius: 10px;
  background: ${({ hasFile }) => (hasFile ? '#f0fdff' : '#fafafa')};
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 70px;

  &:hover {
    border-color: #02b0bb;
    background: #f0fdff;
  }

  input[type='file'] {
    display: none;
  }
`

export const UploadIconContainer = styled.div<{ hasFile?: boolean; isLoading?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: ${({ hasFile, isLoading }) => (isLoading ? '#fef3c7' : hasFile ? '#02b0bb' : '#e5e7eb')};
  color: ${({ hasFile, isLoading }) => (isLoading ? '#d97706' : hasFile ? 'white' : '#6b7280')};
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
    ${({ isLoading }) => isLoading && spinAnimation}
  }
`

export const UploadContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const UploadLabel = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 2px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const UploadHint = styled.p`
  font-size: 0.75rem;
  color: #9ca3af;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const UploadFileName = styled.p`
  font-size: 0.75rem;
  color: #02b0bb;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
`

export const RemoveFileButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: #fee2e2;
  color: #ef4444;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;

  &:hover {
    background: #fecaca;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`

export const CepInputContainer = styled.div`
  position: relative;
  width: 100%;
`

export const CepLoadingIndicator = styled.span`
  position: absolute;
  right: 12px;
  top: 38px;
  font-size: 0.75rem;
  color: #00607f;
  font-weight: 500;
`
